<template>
  <div class="container collection">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{ locale.collection }} &#8250; {{ pageName }}</h1>
        <ItemList v-if="ready"
          :locale="locale"
          :defaultLang="defaultLang"
          :pageId="pageId"
          :categoryId="categoryId"
          :settings="settings"
          :categorySettings="categorySettings"
          :itemList="list"
          :message="message"
          @update="updateItemList"
          @reload="reload" />
      </div>
      <div v-if="categorySettings" class="innerSide">
        <ItemListSettings
          :locale="locale"
          :pageId="pageId"
          :categoryId="categoryId"
          :collectionCategory="categorySettings.collectionCategory"
          :pageUseCollection="settings.useCollection"
          :categorySettings="categorySettings"
          @updateCollectionCategory="updateCollectionCategory" />
      </div>
    </section>
    <div id="setContent">
      <div>
        <div class="innerItem">
          <button type="button" class="btn btnFull btnPrimary" @click="save(null)">{{ locale.save }}</button>
        </div>
        <div class="innerItem">
          <button type="button" class="btn btnFull btnRed" @click="delPage">{{ locale.delete }}</button>
        </div>
        <div class="innerItem">
          <div class="label mb5 setLabel">{{locale.name}}</div>
          <input type="text" class="input" v-model="pageName">
        </div>
        <!-- 기본 설정 -->
        <div class="innerItem">
          <div class="label mb5 setLabel">{{ locale.default_settings }}</div>
          <button class="btn btnFull btnWhite" @click="isSettings = true">{{ locale.setting }}</button>
        </div>
        <!-- //카테고리 설정 -->
        <!-- 카테고리 설정 -->
        <div class="innerItem">
          <div class="label mb5 setLabel">{{locale.category}}</div>
          <button class="btn btnFull btnWhite" @click="isCategory = true">{{ locale.setting }}</button>
        </div>
        <!-- //카테고리 설정 -->
        <!-- 카테고리 설정 -->
        <div class="innerItem">
          <div class="label mb5 setLabel">{{ locale.navigation }}</div>
          <button class="btn btnFull btnWhite" @click="isNav = true">{{ locale.setting }}</button>
        </div>
        <!-- //카테고리 설정 -->
        <!-- 콜렉션 담기 허용 -->
        <div class="innerItem">
          <div class="label mb5 setLabel">{{ locale.use_collection }}</div>
          <div class="checkbox">
            <input type="checkbox" id="use_page_save_collection" v-model="settings.useCollection">
            <label for="use_page_save_collection">{{ locale.allow }}</label>
          </div>
        </div>
        <!-- //콜렉션 담기 허용 -->
        <!-- 마이콜렉션 설정 -->
        <div v-if="settings.useCollection" class="innerItem">
          <div class="label mb5 setLabel">{{ locale.mycollection }}</div>
          <button class="btn btnFull btnWhite" @click="isMyCollection = true">{{ locale.setting }}</button>
        </div>
        <!-- //마이콜렉션 설정 -->
      </div>
    </div>
    <!-- 기본 설정 -->
    <Settings v-if="isSettings"
      :locale="locale"
      :pageId="pageId"
      :settings="settings"
      @save="saveSettings"
      @close="isSettings = false" />
    <!-- //기본 설정 -->
    <!-- 카테고리 설정 -->
    <Category v-if="isCategory"
      :locale="locale"
      :pageId="pageId"
      @reload="getCollectionCategory"
      @close="isCategory = false" />
    <!-- //카테고리 설정 -->
    <!-- 내비게이션 설정 -->
    <Navigation v-if="isNav"
      :locale="locale"
      :pageId="pageId"
      @close="isNav = false" />
    <!-- //내비게이션 설정 -->
    <!-- 마이콜렉션 설정 -->
    <MyCollection v-if="isMyCollection"
      :locale="locale"
      :pageId="pageId"
      @close="isMyCollection = false" />
    <!-- //마이콜렉션 설정 -->
  </div>
</template>

<script>
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import SetLanguageValue from '@/components/Util/SetLanguageValue'
import ItemList from './ItemList'
import ItemListSettings from './ItemListSettings'
import Settings from './Settings'
import Category from './Category'
import Navigation from './Navigation'
import MyCollection from './MyCollection'

export default {
  name: 'CollectionPage',
  props: [
    'locale',
    'pageId',
    'categoryId'
  ],
  components: {
    SetLanguageValue,
    ItemList,
    ItemListSettings,
    Settings,
    Category,
    Navigation,
    MyCollection
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    itemIndexIds () {
      return this.list?.filter(x => x.collectionItemId).map(x => x.collectionItemId)
    }
  },
  watch: {
    pageId () {
      this.init()
    },
    async categoryId (newVal, oldVal) {
      const isDiffCategorySettings = this.isDiffCategorySettings()
      const isDiffItemIndex = this.isDiffItemIndex()
      if (oldVal) {
        // 카테고리 설정값 변경 감지
        if (isDiffCategorySettings && window.confirm('이 리스트의 설정값이 변경되었습니다.\n변경된 설정을 저장하시겠습니까?')) {
          const putCollectionCategorySettings = await this.putCollectionCategorySetting(oldVal)
          if (putCollectionCategorySettings) {
            alert(this.locale.complete_save)
          }
          this.getCollectionItemList()
        }
        // 아이템 순서 변경 감지
        if (isDiffItemIndex) {
          await this.setCollectionItemIndex(oldVal)
        }
      }
      if (newVal) {
        await this.getCollectionItemList()
        await this.getCollectionCategorySetting()
        await this.getMyCollection()
      }
    }
  },
  async created () {
    this.init()
  },
  data () {
    return {
      ready: false,
      catCode: this.catCode || 'system_collection_service',
      message: {
        category: null,
        items: null,
        error: null,
      },
      menu: [
        { id: 'collectionItemList', name: '리스트' },
        { id: 'collectionNav', name: '내비게이션' },
        { id: 'myCollection', name: '마이콜렉션' },
        { id: 'collectionSettings', name: '기본 설정' }
      ],
      isSettings: false,
      isCategory: false,
      isNav: false,
      isMyCollection: false,
      pageName: '',
      settings: {},
      list: [],
      categorySettings: {
        useCollection: true,
        collectionCategory: '',
        listType: 'gallery', // gallery 또는 list
        listColumn: '3',
        columnRatio: ['1', '1', '1'], // listColumn값의 길이
        imageRatio: {
          width: '3',
          height: '2'
        },
        itemRatio: {
          image: '1',
          text: '1'
        },
        itemMarginTb: '1',
        itemMarginLr: '1',
        fontSize: {
          collectionItemName: '24',
          descTop: '16',
          descBottom: '16',
        },
        display: [
          'image',
          'name',
          'descTop',
          'descBottom'
        ]
      },
      categorySettingsOrigin: {},
      itemIndexOrigin: []
    }
  },
  methods: {
    async init () {
      if (!this.pageId) {
        this.$router.replace({
          name: 'collection'
        })
      } else {
        this.$store.commit('collection/setCollectionPage')
        this.$store.commit('collection/setPageCategory')
      }
      this.$store.commit('onLoading', true)
      await this.$store.dispatch('admin/getCodes')
      await this.getCollectionCategory()
      await this.getCollectionPage()
      if (this.categoryId) {
        await this.getCollectionItemList()
        await this.getCollectionCategorySetting()
        await this.getMyCollection()
      }
      this.ready = true
      this.$store.commit('onLoading', false)
    },
    // categoryId로 전체 트리에서 카테고리 찾기
    findCategoryById (categories, id) {
      for (const cate of categories) {
        if (cate.categoryId === id) return cate
        if (cate.subCategory) {
          const found = this.findCategoryById(cate.subCategory, id)
          if (found) return found
        }
      }
      return null
    },
    // 가장 하위카테고리 찾기
    findDeepestId (categoryList, startId) {
      const findCategoryById = (categories, id) => {
        for (const cat of categories) {
          if (cat.categoryId === id) return cat
          if (cat.subCategory) {
            const found = findCategoryById(cat.subCategory, id)
            if (found) return found
          }
        }
        return null
      }
      // 가장 깊은 leaf까지 재귀적으로 탐색
      const findDeepestLeaf = (category) => {
        if (!category || !category.subCategory || category.subCategory.length === 0) {
          return category
        }
        // 하위가 여러 개면 모든 경로 탐색하여 가장 깊은 leaf 리턴
        let deepest = null
        let maxDepth = 0
        const dfs = (node, depth) => {
          if (!node.subCategory || node.subCategory.length === 0) {
            if (depth > maxDepth) {
              maxDepth = depth
              deepest = node
            }
            return
          }
          for (const child of node.subCategory) {
            dfs(child, depth + 1)
          }
        }
        dfs(category, 1)
        return deepest
      }
      const startCategory = findCategoryById(categoryList, startId)
      if (!startCategory) return startId
      const deepest = findDeepestLeaf(startCategory)
      return deepest?.categoryId ?? startId
    },
    // 콜렉션페이지 호출
    async getCollectionPage () {
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/getCollectionPage', this.pageId)
      const page = res?.message
      if (page) {
        this.pageName = page.pageName
        this.catCode = page.catCode
        this.settings = {
          ...this.settings,
          ...page.settings
        }
        this.$store.commit('collection/setCollectionPage', this.pageId)
      } else {
        alert(this.locale.system_error)
        this.$router.replace({
          name: 'collection'
        })
      }
      this.$store.commit('onLoading', false)
    },
    // 콜렉션페이지 카테고리 호출
    async getCollectionCategory () {
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/getCollectionCategory', this.pageId)
      const categories = res?.message?.categories || []
      const removeEmptySubCategory = (arr) => { // 서브카테고리가 비어있으면 키 자체를 삭제
        return arr.map(({ subCategory, ...rest }) => {
          return subCategory && subCategory.length
            ? { ...rest, subCategory: removeEmptySubCategory(subCategory) }
            : rest
        })
      }
      // const categoryList = removeEmptySubCategory(categories)
      if (categories.length > 0) {
        const categoryList = removeEmptySubCategory(categories)
        this.category = categoryList
        this.message.category = null
        this.$store.commit('collection/setPageCategory', categoryList)
        if (categoryList && this.categoryId && !this.findCategoryById(categoryList, this.categoryId)) { // 카테고리 못찾으면 첫번째 카테고리id
          this.$router.replace({
            params: {
              categoryId: this.findDeepestId(categoryList, categoryList[0].categoryId)
            }
          })
        }
      } else {
        this.category = []
        this.message.category = '카테고리를 생성해 주세요.'
        this.$router.replace({
          params: {
            categoryId: 'unknown'
          }
        })
      }
      this.$store.commit('onLoading', false)
    },
    // 마이콜렉션 설정 호출 (콜렉션 카테고리 선택에 사용)
    async getMyCollection () {
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/getMyCollection', this.pageId)
      const myCollection = res?.message?.myCollectionSetting
      const categories = myCollection?.category
      const removeEmptySubCategory = (arr) => { // 서브카테고리가 비어있으면 키 자체를 삭제
        return arr.map(({ subCategory, ...rest }) => {
          return subCategory && subCategory.length
            ? { ...rest, subCategory: removeEmptySubCategory(subCategory) }
            : rest
        })
      }
      const myCollectionCategory = categories && removeEmptySubCategory(categories)
      if (myCollection) {
        this.$store.commit('collection/setMyCollectionCategory', myCollectionCategory)
      } else {
        alert(this.locale.system_error)
      }
      this.$store.commit('onLoading', false)
    },
    // 콜렉션 아이템 리스트 호출
    async getCollectionItemList () {
      const data = {
        pageId: this.pageId,
        categoryId: this.categoryId
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/getCollectionItemList', data)
      const items = res?.message?.collectionItems || []
      // 아이템 리스트
      this.list = items
      // 아이템 리스트 순서 origin
      this.itemIndexOrigin = items.filter(x => x.collectionItemId).map(x => x.collectionItemId)
      this.message.items = items?.length === 0 ? '콜렉션 아이템을 등록해 주세요.' : null
      this.$store.commit('onLoading', false)
    },
    // 콜렉션 카테고리 세팅 호출
    async getCollectionCategorySetting () {
      const data = {
        pageId: this.pageId,
        categoryId: this.categoryId
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/getCollectionCategorySetting', data)
      const categorySettings = res?.message?.categorySetting
      if (categorySettings) {
        this.categorySettingsOrigin = this._.cloneDeep(categorySettings)
        this.categorySettings = this._.cloneDeep(categorySettings)
      }
      if (!this.settings.useCollection) {
        this.categorySettings.useCollection = false
      }
      this.$store.commit('onLoading', false)
    },
    // 콜렉션 카테고리 세팅 업데이트
    async putCollectionCategorySetting (categoryId) {
      const data = {
        pageId: this.pageId,
        categoryId: categoryId || this.categoryId,
        categorySetting: this.categorySettings
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/putCollectionCategorySetting', data)
      return res?.status === 200
      this.$store.commit('onLoading', false)
    },
    // 콜렉션 카테고리 아이템 인덱스 저장
    async setCollectionItemIndex (categoryId) {
      const data = {
        pageId: this.pageId,
        categoryId: categoryId || this.categoryId,
        collectionItemIndex: this.itemIndexIds
      }
      const res = await this.$store.dispatch('collection/setCollectionItemIndex', data)
      if (res?.status === 200) {
        await this.getCollectionCategorySetting()
      }
      return res?.status === 200
    },
    updateItemList (list) {
      this.list = list
    },
    updateCollectionCategory (categoryId) {
      this.categorySettings.collectionCategory = categoryId
    },
    reload () {
      this.getCollectionItemList()
    },
    // 콜렉션페이지 삭제
    async delPage () {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('collection/deleteCollectionPage', this.pageId)
        if (res?.status === 200) {
          alert(this.locale.complete_delete)
          this.$router.replace({
            name: 'collection'
          })
        }
        this.$store.commit('onLoading', false)
        
      }
    },
    // 카테고리 설정 저장
    saveSettings (data) {
      this.settings = {
        ...this.settings,
        ...data
      }
      this.save()
    },
    // 카테고리 설정 변경 여부 확인
    isDiffCategorySettings () {
      const origin = this.categorySettingsOrigin
      const current = this.categorySettings
      return !this._.isEqual(origin, current)
    },
    // 아이템 순서 변경 여부 확인
    isDiffItemIndex () {
      const origin = this.itemIndexOrigin
      const current = this.itemIndexIds
      return !this._.isEqual(origin, current)
    },
    async save () {
      const data = {
        pageId: this.pageId,
        catCode: this.catCode,
        pageName: this.pageName,
        settings: this.settings
      }
      const isDiffCategorySettings = this.isDiffCategorySettings()
      const isDiffItemIndex = this.isDiffItemIndex()
      this.$store.commit('onLoading', true)
      if (isDiffCategorySettings) {
        await this.putCollectionCategorySetting()
        this.getCollectionCategorySetting()
      }
      if (isDiffItemIndex) {
        await this.setCollectionItemIndex()
      }
      const res = await this.$store.dispatch('collection/updateCollectionPage', data)
      if (res?.status === 200) {
        alert(this.locale.complete_save)
        await this.getCollectionPage()
        this.isSettings = false
      }
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.innerSide {
  overflow: auto;
}
</style>
